import { createSelector } from "reselect";
import { RootState } from "@/store";
import { CarState } from "@/store/slices/data/CarSlice";

/**
 * Sélecteur pour obtenir l'état d'un véhicule'.
 *
 * @param {RootState} state - L'état de l'application.
 * @returns {CarState} - L'état des marques.
 */
const selectCarState = (state: RootState): CarState => state.car;

/**
 * Sélecteur pour obtenir un véhicule.
 *
 * @returns {any[]} - Toutes les marques.
 */
export const selectCar = createSelector(selectCarState, (carState) => carState.car);

/**
 * Sélecteur pour obtenir les états de chargement d'un véhicule'.
 *
 * @returns {object} - Un objet avec les états de chargement.
 */
export const selectCarLoadingStates = createSelector([selectCarState], (carState) => ({
  isLoading: carState.loading === "pending",
  isSucceeded: carState.loading === "succeeded",
  isFailed: carState.loading === "failed",
  isIdle: carState.loading === "idle",
}));

/**
 * Sélecteur pour obtenir les erreurs d'un véhicule.
 *
 * @returns {string | null} - Les erreurs.
 */
export const selectCarError = createSelector(selectCarState, (carState) => carState.error);
